import {useRouter} from 'next/router';
import { prefix } from '../../lib/auth';
import LandingHeadingText from '../ui/landing-heading-text';
import DynamicIcon from '../ui/dynamic-icon';
import { useTranslations } from 'next-intl';

const LandingWorkpegEmail = () => {
    const router = useRouter();
    const t = useTranslations('landing');

    return (
        <div className='max-w-[90%] lg:max-w-[1120px] m-auto grid gap-[60px] pb-[100px] lg:pb-[131.2px]'>
            <div className='grid gap-[17px] lg:gap-[25.59px] max-w-[591px] m-auto'>
                <LandingHeadingText additionalclasses='!text-center'>{t('whatsInMailHeading')}</LandingHeadingText>
                <p className='text-[16px] leading-[26px] text-[#666666] text-center'>{t('whatsInMailSubtitle')} <br /><span className='hidden lg:block'>{t('whatsInMailSubtitleLine2')}</span></p>
            </div>
            <div className='grid lg:grid-cols-3 gap-[24px] lg:gap-[4px] px-[5px] py-[11px] border-[1px] border-[#0000000D] rounded-[8px]'>
                <div className='p-[20px] bg-white rounded-[4px] grid gap-[55px]  min-h-[243px] lg:min-h-fit border-[1px] border-[#0000000D]'>
                    <div className='grid items-center justify-center h-[40px] w-[40px] rounded-[4px] bg-[#0000000D]'>
                        <DynamicIcon name='file-text' size={20} color='text-grey-900' />
                    </div>
                    <div className='grid gap-[10.8px]'>
                        <p className='text-[22px] tracking-[-0.44px] leading-[30.8px] text-grey-900'>{t('customDomainTitle')}</p>
                        <p className='text-[14px] leading-[22px] text-[#666666]'>{t('customDomainDesc')}</p>
                    </div>
                </div>
                <div className='p-[20px] bg-white rounded-[4px] grid gap-[55px]  min-h-[243px] lg:min-h-fit border-[1px] border-[#0000000D]'>
                    <div className='grid items-center justify-center h-[40px] w-[40px] rounded-[4px] bg-[#0000000D]'>
                        <DynamicIcon name='square-code' size={20} color='text-grey-900' />
                    </div>
                    <div className='grid gap-[10.8px]'>
                        <p className='text-[22px] tracking-[-0.44px] leading-[30.8px] text-grey-900'>{t('teamManagementTitle')}</p>
                        <p className='text-[14px] leading-[22px] text-[#666666]'>{t('teamManagementDesc')}</p>
                    </div>
                </div>
                <div className='grid p-[20px] content-end min-h-[243px] lg:min-h-fit'>
                    <div className='flex items-end justify-between'>
                        <div className='grid gap-[10.8px]'>
                            <p className='text-[16px] leading-[22.4px] text-grey-900'>{t('workpegMailVersion')}</p>
                            <p className='text-[14px] leading-[22px] text-[#666666]'>{t('smarterInboxes')}<br/> {t('getStartedNow')}</p>
                        </div>
                        <div 
                        onClick={() => router.push(`http://${prefix()}accounts.workpeg.com/register?peg=email`)}
                        className='grid items-center justify-center h-[40px] w-[40px] rounded-[4px] bg-[#0000000D] cursor-pointer'>
                            <DynamicIcon name='move-right' size={20} color='text-grey-900' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingWorkpegEmail;